import { adminStyles as styles } from "./adminStyles";

function AdminEmptyState({ children }) {
  return <div style={styles.state}>{children}</div>;
}

export default AdminEmptyState;